<template>
    <div>
        <button v-on="$listeners" v-bind="$attrs" class="btn btn-2" :class="buttonClass">
            <slot/>
        </button>
    </div>
</template>

<script>
    export default {
        name: "BaseButtonStyle",
        inheritAttrs: false,
        props: {
            buttonClass: {
                type: String
            }
        }
        
    }
</script>

<style scoped>
body{
  font-family: 'Montserrat', sans-serif;
  margin:0;
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  width: 80vw;
  margin: 0 auto;
  min-height: 100vh;
}
.btn {
  flex: 1 1 auto;
  margin: 10px;
  padding: 10px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
 /* text-shadow: 0px 0px 10px rgba(0,0,0,0.2);*/
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  border-color: #07e807;
  cursor: pointer;

 
 }

/* Demo Stuff End -> */

/* <- Magic Stuff Start */

.btn:hover {
    background-position: right center; /* change the direction of the change here */
    -webkit-transform: scale(1.02);
    transform: scale(1.02);
    box-shadow: 0 7px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn-2 {
  background-image: linear-gradient(to right, #fbc2eb 0%, #a6c1ee 51%, #fbc2eb 100%);

}

.btn-3 {
  background-image: linear-gradient(to right, #84fab0 0%, #8fd3f4 51%, #84fab0 100%);
}
.btn-4 {
  background-image: linear-gradient(to right, #a1c4fd 0%, #c2e9fb 51%, #a1c4fd 100%);
}

.btn-5 {
  background-image: linear-gradient(to right, #ffecd2 0%, #fcb69f 51%, #ffecd2 100%);
}

/* Example of styling the icon */
i {
  color: #111111; /* Change the color of icons */
}

</style>